import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';

import './calculators-articles.scss';

function CalculatorsArticlePhotos({ photos = [] }) {
  return photos.map(photo => (
    <Fragment key={photo.href}>
      <img
        alt={photo.title || photo.captionTranscript}
        className="w-100"
        src={getFullImageUrl(photo.href, IMAGE_SIZES.lg)}
        loading="lazy"
      />
      {photo.captionTranscript && <p className="xsmall mb-0 photo-title py-0_5">{photo.captionTranscript}</p>}
    </Fragment>
  ));
}

CalculatorsArticlePhotos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({})),
};

function CalculatorsArticle({ article = DEFAULT_CONTENT }) {
  const { id, title } = article;

  return (
    <Fragment key={id}>
      {title && <h3 className="heading-5 mb-0">{title}</h3>}
      <ContentFragment componentToUse="div" classes="mb-1 size-16">
        {article.metadata('content').value()}
      </ContentFragment>
    </Fragment>
  );
}

CalculatorsArticle.propTypes = {
  article: CmsEntities.Content,
};

export function CalculatorsArticles({
  articles = DEFAULT_CONTENT,
  title = '',
  author = '',
  date = '',
  className = '',
}) {
  return (
    <section className={classnames('calculators-articles text-gray-darker', className)}>
      {title && <h2 className="heading-3">{title}</h2>}
      {author && <p className="size-14 mb-0_25">By {author}</p>}
      {date && <p className="size-14 mb-2">{date}</p>}
      {articles.map(entry =>
        /^photo/.test(entry.id) ? (
          <CalculatorsArticlePhotos key={entry.id} photos={entry.links()} />
        ) : (
          <CalculatorsArticle key={entry.id} article={entry} />
        )
      )}
    </section>
  );
}

CalculatorsArticles.propTypes = {
  articles: PropTypes.arrayOf(CmsEntities.Content),
  title: PropTypes.string,
  author: PropTypes.string,
  date: PropTypes.string,
  className: PropTypes.string,
};
